import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    Checkbox,
    ListItemText,

} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    resetUpdateWalletDetails,
    updateWalletDetailsReq
} from "../../redux/actions/updateoraddwalletownerbankdetailsAction";
import { updateCustomerBankDetailsReq, resetUpdateCustomerBankDetails } from "../../redux/actions/updateOrAddCustomerBankDetailsAction";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { partnerCountryList } from '../../redux/actions/countryListForPartnerAction';
import { partnerGetMappingBankName } from "../../redux/actions/getMappingBankNameListAction";
import {

    getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import Autocomplete from "@mui/material/Autocomplete";
import { customerCurrencyDropdown } from "../../utils/customerCurrencyDropdown";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";

const AddCustomerBankDetails = () => {
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    const dispatch = useDispatch();
    const [BankName, setBankName] = useState("");
    // const [currency, setCurrency] = useState("");
    const [currency, setCurrency] = useState([]);
    const [accountNumber, setAccountNumber] = useState("");
    const [SFBCode, setSFBCode] = useState("");
    const [sortCode, setSortCode] = useState("");
    const [routingCode, setRoutingCode] = useState("");
    const [IBANNumber, setIBANNumber] = useState("");
    const [accountHolder, setAccountHolder] = useState("");
    const [bankCountry, setBankCountry] = useState("");
    const [bankAddress, setBankAddress] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [bcontactNumber, setBContactNumber] = useState("");
    const [BcontactPerson, setBcontactPerson] = useState("");
    const [isBankDefault, setIsBankDefault] = useState("");
    const [updateoraddwalletownerArray, setUpdateoraddwalletownerArray] =
        useState("");
    const [updatewalletpopup, setupdatewalletpopup] = useState(false);
    const [updatewalletstatus, setupdatewalletstatus] = useState(false);
    const [selectedCountry, setselectedCountry] = useState('');
    const [countryList, setcountryList] = useState([])
    const [getBankType, setGetBankType] = useState('')
    const [isLoading, setIsLoading] = useState(true);
    const [getBankNameListArray, setGetBankNameListArray] = useState([]);
    const [getBankName, setGetBankName] = useState([])
    const [getBankNameListStatus, setGetBankNameListStatus] = useState(false);
    const [autocompleteCustomerIDData, setautocompleteCustomerIDData] =
        useState("");
    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );
    const updateOrAddCustomerbankdetailsRes = useSelector(
        ({ updateOrAddcustomerbankDetailsLists }) => updateOrAddcustomerbankDetailsLists
    );
    console.log("updateADDRes", updateOrAddCustomerbankdetailsRes);
    const getCountryListRes = useSelector(({ countryListsForPartner }) => countryListsForPartner);
    console.log("getCountryListRes", getCountryListRes)
    const getBankNameListRes = useSelector(({ getMappingBanksNamesLists }) => getMappingBanksNamesLists);
    const adminCurrencyList = useSelector(
        ({ adminCurrencyList }) => adminCurrencyList
    );

    const loginData = useSelector(({ login }) => login);

    const getdefaultcurrrencylistres = useSelector(({ getDefaultCurrencyList }) => getDefaultCurrencyList)
    console.log("getdefaultcurrrencylistres", getdefaultcurrrencylistres)
    const navigate = useHistory();
    // const handleChange = ({ target: { name, value } }) => {
    //   if (name === "BcontactPerson") {
    //     setBcontactPerson(value);
    //   }

    //   if (name === "currency") {
    //     // setCurrency(value);
    //     setCurrency(value == "Select Currency" ? "" : value);
    //   }

    //   if (name === "BankName") {
    //     setBankName(value);
    //   }

    //   if (name === "accountNumber") {
    //     setAccountNumber(value);
    //   }

    //   if (name === "accountNumber") {
    //     setAccountNumber(value);
    //   }

    //   if (name === "SFBCode") {
    //     setSFBCode(value);
    //   }

    //   if (name === "sortCode") {
    //     setSortCode(value);
    //   }

    //   if (name === "routingCode") {
    //     setRoutingCode(value);
    //   }

    //   if (name === "IBANNumber") {
    //     setIBANNumber(value);
    //   }

    //   if (name === "accountHolder") {
    //     setAccountHolder(value);
    //   }

    //   if (name === "bankCountry") {
    //     setBankCountry(value);
    //   }

    //   if (name === "bankAddress") {
    //     setBankAddress(value);
    //   }

    //   if (name === "zipCode") {
    //     setZipCode(value);
    //   }

    //   if (name === "bcontactNumber") {
    //     setBContactNumber(value);
    //   }

    //   if (name === "isBankDefault") {
    //     //  setIsBankDefault(value);
    //     setIsBankDefault(value == "Select Status" ? "" : value);
    //   }
    // };
    // const currencyListData = customerCurrencyDropdown.map(item => item.currency);



    const handleCurrencyChange = (event) => {
        const value = event.target.value;

        if (value.includes("all")) {
            if (currency.length === currencyListData.length) {
                setCurrency([]); // unselect all
            } else {
                setCurrency(currencyListData); // select all
            }
        } else {
            setCurrency(value);
        }
    };
    // const handleCurrencyChange = (event) => {
    //     const {
    //         target: { value }
    //     } = event;

    //     let selectedValue = typeof value === "string" ? value.split(",") : value;

    //     if (selectedValue.includes("all")) {
    //         if (currency.length === currencyList.length) {
    //             setCurrency([]);
    //         } else {
    //             setCurrency(currencyList);
    //         }
    //     } else {
    //         setCurrency(selectedValue);
    //     }
    // };
    // const currencyList =
    //     adminCurrencyList?.success
    //         ? [...new Set(adminCurrencyList.data.currencyList)]
    //         : [];
    const handleChange = ({ target: { name, value } }) => {
        // if (name === "BankId") {
        //   setBankId(value);
        // }
        if (name === "countryList") {
            setselectedCountry(value === "Select Country" ? "" : value);


            // console.log('Selected Country: ', value);
        }
        if (name === "BcontactPerson") {
            // setBcontactPerson(value);
            Util.verifyAlphabet(value)
                ? setBcontactPerson(value)
                : setBcontactPerson(BcontactPerson);
        }
        if (name === "getBankName") {
            // setBankName(value)
            setGetBankName(value == "Select Bank" ? "" : value);

        }

        // if (name === "bankname") {
        //   // setbankname(value);
        //   Util.alphaNumeric(value) ? setbankname(value) : setbankname(bankname);
        // }

        // if (name === "currency") {
        //     //setCurrency(value);
        //     setCurrency(value == "Select Currency" ? "" : value);
        // }

        // if (name === "BankName") {
        //     // setBankName(value);
        //     Util.alphaNumeric(value) ? setBankName(value) : setBankName(BankName);
        // }

        if (name === "accountNumber") {
            // setAccountNumber(value);
            Util.verifyMobile(value)
                ? setAccountNumber(value)
                : setAccountNumber(accountNumber);
        }

        // if (name === "accountNumber") {
        //   setAccountNumber(value);
        // }

        if (name === "SFBCode") {
            // setSFBCode(value);
            Util.alphaNumeric(value) ? setSFBCode(value) : setSFBCode(SFBCode);
        }

        // if (name === "sortCode") {
        //     // setSortCode(value);
        //     Util.verifyMobile(value) ? setSortCode(value) : setSortCode(sortCode);
        // }
        if (name === "sortCode") {
            // allow only digits and hyphen
            let cleanedValueSort = value.replace(/[^0-9-]/g, "");

            // optional: prevent multiple consecutive hyphens
            cleanedValueSort = cleanedValueSort.replace(/--+/g, "-");

            setSortCode(cleanedValueSort);
        }

        if (name === "routingCode") {
            // setRoutingCode(value);
            Util.verifyMobile(value)
                ? setRoutingCode(value)
                : setRoutingCode(routingCode);
        }

        if (name === "IBANNumber") {
            // setIBANNumber(value);
            Util.alphaNumeric(value)
                ? setIBANNumber(value)
                : setIBANNumber(IBANNumber);
        }

        if (name === "accountHolder") {
            // setAccountHolder(value);
            Util.verifyAlphabet(value)
                ? setAccountHolder(value)
                : setAccountHolder(accountHolder);
        }

        if (name === "bankCountry") {
            // setBankCountry(value);
            Util.verifyAlphabet(value)
                ? setBankCountry(value)
                : setBankCountry(bankCountry);
        }

        // if (name === "bankAddress") {
        //     // setBankAddress(value);
        //     Util.alphaNumeric(value)
        //         ? setBankAddress(value)
        //         : setBankAddress(bankAddress);
        // }
        if (name === "bankAddress") {
            const cleanedValue = value.replace(/[^a-zA-Z0-9,\s]/g, "");
            setBankAddress(cleanedValue);
        }

        if (name === "zipCode") {
            Util.alphaNumeric(value) ? setZipCode(value) : setZipCode(zipCode);
        }

        // if (name === "bcontactNumber") {
        //     // setBContactNumber(value);
        //     Util.verifyMobile(value)
        //         ? setBContactNumber(value)
        //         : setBContactNumber(bcontactNumber);
        // }
        if (name === "bcontactNumber") {
            // allow digits, + and space
            const cleanedValueD = value.replace(/[^0-9+\s]/g, "");

            // optional: allow only one '+' at start
            if (cleanedValueD.includes("+")) {
                const formatted =
                    "+" +
                    cleanedValueD
                        .replace(/\+/g, "") // remove all +
                        .replace(/^\+/, ""); // safety

                setBContactNumber(formatted);
            } else {
                setBContactNumber(cleanedValueD);
            }
        }

        if (name === "isBankDefault") {
            // setIsBankDefault(value);
            setIsBankDefault(value == "Select Status" ? "" : value);
        }
    };



    // console.log("Curr: ", adminCurrencyList);

    const getCountryResp = () => {
        if (getCountryListRes.data.status === 'success') {
            setIsLoading(false);
            setcountryList(getCountryListRes.data.list);
        }
    }

    useEffect(() => {
        getCountryResp();
    }, [getCountryListRes.data.status]);
    useEffect(() => {
        getCountryListListReq()
    }, []);

    const getCountryListListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                bankType: "local"

            }
        }
        dispatch(partnerCountryList(req, authToken));
        setGetBankType()
    };

    // const CurrencyListFunc = (walletOwnerIds) => {
    //     const WalletAcRequired = {
    //         loginDetails: {
    //             walletOwnerId: loginData.data.partnerId,
    //             role: loginData.data.subRole
    //         },
    //     };

    //     return dispatch(getDefaultCurrencyList(WalletAcRequired, authToken));
    // };

    useEffect(() => {
        if (regenerateTokenRes.data.status === "success") {
            dispatch(getDefaultCurrencyList({
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                }
            }, authToken));
        }
    }, [regenerateTokenRes.data.status]);




    // useEffect(() => {
    //     CurrencyListFunc();
    // }, []);

    const currencyListData =
        adminCurrencyList?.success &&
            adminCurrencyList?.data?.status === "success"
            ? [].concat(adminCurrencyList.data.currencyList || [])
            : [];



    // const getBankNameListReq = () => {
    //     setGetBankNameListStatus(true)
    //     const Request = {
    //         actionCustomerMasterRequestVO: {
    //             walletOwnerId: regenerateTokenRes.data.partnerId,
    //             country: selectedCountry,

    //         }
    //     }
    //     dispatch(partnerGetMappingBankName(Request, authToken));

    // }

    // const getBankNameListFunc = () => {
    //     if (getBankNameListStatus) {
    //         if (getBankNameListRes.data.status == "success") {
    //             setGetBankNameListArray(getBankNameListRes.data.customerMasterDetailsRequestVOList);
    //         }
    //         if (getBankNameListRes.data.status == "failed") {
    //             setGetBankNameListArray(getBankNameListRes.data);
    //         }
    //     }
    // };

    // useEffect(() => {
    //     if (selectedCountry) {
    //         getBankNameListReq()
    //     }
    // }, [selectedCountry])

    // useEffect(() => {
    //     getBankNameListFunc()
    // }, [getBankNameListRes.data.status])



    const updateBankDetails = () => {
        setupdatewalletstatus(true);
        const cleanedBankAddress = (bankAddress || "").replace(/[^a-zA-Z0-9,\s]/g, "");
        const cleanedContactNumber = (bcontactNumber || "").replace(/[^0-9+\s]/g, "");
        const cleanedSortCode = (sortCode || "")
            .replace(/[^0-9-]/g, "")
            .replace(/--+/g, "-");
        const updateWalletOwnerBankViewReq = {
            loginDetails: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                customerId: autocompleteCustomerIDData ? autocompleteCustomerIDData.split('-')[0] : "",
            },
            bankDetailsVO: {
                bankId: "",
                accountHolder: accountHolder,
                accountNumber: accountNumber,
                bankAddress: cleanedBankAddress,
                bankContactNo: cleanedContactNumber,
                bankContactPerson: BcontactPerson,
                bankCountry: bankCountry,
                bankCurrency: currency,
                bankName: getBankName,
                bankZip: zipCode,
                ibanNumber: IBANNumber,
                ifscCode: SFBCode,
                isBankDefault: isBankDefault,
                routingCode: routingCode,
                sortCode: cleanedSortCode
            }
        };

        return dispatch(
            updateCustomerBankDetailsReq(updateWalletOwnerBankViewReq, authToken)
        );
    };



    const handleClose = () => {
        setupdatewalletpopup(false);
        if (
            updateoraddwalletownerArray.status === "success" ||
            updateoraddwalletownerArray.status === "Already Exists"
        ) {

            resetForm();

            navigate.push("/index/customer-bank");

        }
    };

    useEffect(() => {
        if (updatewalletstatus) {
            if (updateOrAddCustomerbankdetailsRes.data.status == "success") {
                setUpdateoraddwalletownerArray(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setupdatewalletpopup(true);
            }
            if (updateOrAddCustomerbankdetailsRes.data.status == "Failed") {
                setUpdateoraddwalletownerArray(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setupdatewalletpopup(true);
                if (
                    updateOrAddCustomerbankdetailsRes.data.description ==
                    "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateOrAddCustomerbankdetailsRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (updateOrAddCustomerbankdetailsRes.data.status == "failed") {
                setUpdateoraddwalletownerArray(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setupdatewalletpopup(true);
                if (
                    updateOrAddCustomerbankdetailsRes.data.description ==
                    "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateOrAddCustomerbankdetailsRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (updateOrAddCustomerbankdetailsRes.data.status == "Already Exists") {
                setUpdateoraddwalletownerArray(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setupdatewalletpopup(true);
                if (
                    updateOrAddCustomerbankdetailsRes.data.description ==
                    "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateOrAddCustomerbankdetailsRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }, [updateOrAddCustomerbankdetailsRes.data.status]);


    useEffect(() => {
        if (getCustomerIdAndNameListRes.data.status === "Success") {
            // console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
        }
    }, [getCustomerIdAndNameListRes.data.status])

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || ""
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: ""
                }
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);
    const filterOptionsL = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }

    const isFormValid = () => {
        return (
            autocompleteCustomerIDData &&

            getBankName &&
            currency &&
            accountNumber &&
            SFBCode &&
            sortCode &&
            IBANNumber &&
            accountHolder
        );
    };

    const resetForm = () => {
        setCurrency([]);
        setAccountNumber("");
        setSFBCode("");
        setSortCode("");
        setRoutingCode("");
        setIBANNumber("");
        setAccountHolder("");
        setBankCountry("");
        setBankAddress("");
        setZipCode("");
        setBContactNumber("");
        setBcontactPerson("");
        setIsBankDefault("");
        setGetBankName("");
        setautocompleteCustomerIDData(null);
    };

    return (
        <Layout>
            <BackButton />
            <Card>
                <Grid container style={{ padding: "10px" }}>
                    <Grid item xs={12} md={2} lg={2}></Grid>

                    <Grid item xs={12} md={8} lg={8}>
                        <div style={{ marginTop: "1.5rem" }}>
                            {/* <Grid item xs={12} sm={12} md={4} lg={4}> */}
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsL}
                                value={autocompleteCustomerIDData}
                                onChange={(event, value) =>
                                    setautocompleteCustomerIDData(value)
                                }

                                renderInput={(params) => (

                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Customer ID"
                                        // style={{ marginTop: "3px" }}
                                        // required
                                        type="text"
                                        fullWidth
                                        {...params}
                                        className="new1"
                                        // value={getCustomerId || ""}
                                        // name="getCustomerId"
                                        onBlur={handleChange}
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                        variant="standard"
                                    />
                                )}
                            />
                            {/* </Grid> */}
                        </div>
                        {/* <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Country"
                                fullWidth={true}
                                name="countryList"
                                value={selectedCountry || ''}
                                onChange={handleChange}
                                variant='standard'
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {countryList &&
                                    [].concat(countryList).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))}
                            </TextField>

                        </div> */}

                        {/* <div style={{ marginTop: "1.5rem" }}>
                            {" "}  */}
                        {/* <TextField
                                name="BankName"
                                margin="dense"
                                label="Bank Name"
                                type="name"
                                required
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={BankName || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />  */}


                        {/* <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                required
                                label="Bank Name"
                                fullWidth={true}
                                name="getBankName"
                                value={getBankName || ''}
                                onChange={handleChange}
                                variant='standard'
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}

                            >
                              

                            </TextField>
                        </div> */}
                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <TextField
                                margin="dense"
                                label="Bank Name"
                                type="text"
                                // required
                                name="getBankName"
                                value={getBankName || ''}
                                fullWidth
                                variant="standard"
                                onChange={handleChange}

                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            {/* <TextField
                                select
                                margin="dense"
                                label="Currency"
                                name="currency"
                                type="text"
                                required
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                //value={currency || ""}
                                defaultValue={"Select Currency" || currency}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Currency" selected="Select Currency">
                                    Select Currency
                                </MenuItem>
                                {adminCurrencyList.success &&
                                    []
                                        .concat(adminCurrencyList.data.currencyList)
                                        .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                            </TextField> */}
                            {/* <FormControl fullWidth variant="standard" style={{ }}>
                                <InputLabel>Currency</InputLabel>

                                <Select
                                required
                                    multiple
                                    value={currency || []}
                                    onChange={handleCurrencyChange}
                                    renderValue={(selected) => selected.join(", ")}
                                >

                                    <MenuItem value="all">
                                        <Checkbox
                                            checked={
                                                currencyList.length > 0 &&
                                                currency.length === currencyList.length
                                            }
                                        />
                                        <ListItemText primary="All" />
                                    </MenuItem>

                                    {currencyList.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            <Checkbox checked={currency.indexOf(item) > -1} />
                                            <ListItemText primary={item} />
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl> */}
                            <FormControl fullWidth variant="standard">
                                <InputLabel
                                // required
                                >Currency</InputLabel>

                                <Select
                                    multiple
                                    value={currency}
                                    onChange={handleCurrencyChange}
                                    renderValue={(selected) => selected.join(", ")}
                                >
                                    {/* Select All */}
                                    <MenuItem value="all">
                                        <Checkbox
                                            checked={
                                                currency.length === currencyListData.length &&
                                                currencyListData.length > 0
                                            }
                                        />
                                        <ListItemText primary="All" />
                                    </MenuItem>

                                    {/* Currency List */}
                                    {currencyListData.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            <Checkbox checked={currency.indexOf(item) > -1} />
                                            <ListItemText primary={item} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <TextField
                                margin="dense"
                                label="Account Holder Name"
                                type="text"
                                // required
                                name="accountHolder"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={accountHolder || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <TextField
                                margin="dense"
                                label="IBAN Number"
                                name="IBANNumber"
                                type="text"
                                fullWidth
                                // required
                                variant="standard"
                                onChange={handleChange}
                                value={IBANNumber || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="SWIFT/IFSC/BIC Code"
                                type="text"
                                fullWidth

                                name="SFBCode"
                                variant="standard"
                                onChange={handleChange}
                                value={SFBCode || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                name="accountNumber"
                                margin="dense"
                                label="Account Number"
                                type="name"
                                fullWidth
                                // required
                                variant="standard"
                                onChange={handleChange}
                                value={accountNumber || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="Sort Code"
                                name="sortCode"
                                type="text"
                                fullWidth
                                // required
                                variant="standard"
                                onChange={handleChange}
                                value={sortCode || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="ABA Routing Code(US)"
                                type="text"
                                fullWidth

                                name="routingCode"
                                variant="standard"
                                onChange={handleChange}
                                value={routingCode || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>





                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="Bank Country"
                                name="bankCountry"
                                type="text"

                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={bankCountry || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <TextField
                                margin="dense"
                                label="Bank Address"
                                type="text"
                                name="bankAddress"

                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={bankAddress || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>
                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="Bank Zip Code"
                                name="zipCode"

                                onChange={handleChange}
                                type="text"
                                fullWidth
                                variant="standard"
                                value={zipCode || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>

                        {/* <div style={{ marginTop: "1.5rem" }}>
            <Typography variant="body1" align="justify" gutterBottom={true}>
              State:
            </Typography>
            <TextField
              size="small"
              color="primary"
              type="string"
              // label="state"
              variant="outlined"
              fullWidth={true}
              name="state"
              value={state}
              onChange={(e) => onInputChange(e)}
            />
          </div> */}

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="Bank Contact Number"

                                type="text"
                                name="bcontactNumber"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                value={bcontactNumber || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                margin="dense"
                                label="Bank Contact Person"
                                type="text"
                                fullWidth

                                name="BcontactPerson"
                                variant="standard"
                                onChange={handleChange}
                                value={BcontactPerson || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </div>

                        <div style={{ marginTop: "1.5rem" }}>
                            <TextField
                                select
                                margin="dense"
                                label="Is Bank Default"
                                name="isBankDefault"

                                type="text"
                                fullWidth
                                variant="standard"
                                onChange={handleChange}
                                // defaultValue={isBankDefault || "Select Status"}
                                value={isBankDefault || ""}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Status">Select Status</MenuItem>
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField>
                        </div>

                        <div className="text-center" style={{ marginTop: "2.5rem" }}>
                            <CustomButton
                                style={{
                                    padding: "12px"
                                }}
                                onClick={updateBankDetails}

                            // disabled={!isFormValid()}
                            >
                                Submit
                            </CustomButton>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={2} lg={2}></Grid>
                </Grid>
            </Card>

            {updatewalletpopup && (
                <div>
                    <Dialog open={updatewalletpopup} onClose={handleClose}>
                        <DialogContent className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}

                        >
                            {updateoraddwalletownerArray.status == "success" || updateoraddwalletownerArray.status == "Already Exists" ? (
                                <img src={success} alt="" width="100px" className="my-2" />
                            ) : (
                                <img src={failed} alt="" width="100px" className="my-2" />
                            )}
                        </DialogContent>
                        <DialogContent>
                            <h3
                                style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
                            >
                                {updateoraddwalletownerArray.description}
                            </h3>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </Layout>
    );
};

export default AddCustomerBankDetails;